<template>
    <div class="bubble-notification-modal">

        <div class="bubble-notification-modal__header">
            <div class="icon-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60"><g data-name="Group 256" transform="translate(-150 -366)"><circle data-name="Ellipse 59" cx="30" cy="30" r="30" transform="translate(150 366)" fill="#f5f5f5"/><path data-name="Icon awesome-crown" d="M193 408h-26a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h26a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1Zm4-20a3 3 0 0 0-3 3 2.939 2.939 0 0 0 .275 1.238l-4.525 2.712a2 2 0 0 1-2.763-.725l-5.093-8.912a3 3 0 1 0-3.788 0l-5.094 8.912a2 2 0 0 1-2.763.725l-4.518-2.713A3 3 0 1 0 163 394a3.063 3.063 0 0 0 .481-.05L168 406h24l4.519-12.05a3.063 3.063 0 0 0 .481.05 3 3 0 1 0 0-6Z" fill="#c59264"/></g></svg>
            </div>

            <div class="img-wrapper">
                <img :src="getUserPhotoURL(bubble.payload.user)" alt="User Photo">
            </div>
        </div>
        <div class="text">
            {{themeT('notifications.premium.title')}}
        </div>
        <h2>
            {{themeT('notifications.premium.subtitle')}}
        </h2>
        <button @click="messageUser" :disabled="working" class="button button--primary">{{$t(`notifications.actions.send_message.${bubble.payload.user.gender === TYPE_GENDER_FEMALE ? 'female' : 'male'}`)}}</button>
        <router-link class="button button--fourth" @click="$emit('close'); pushDataLayer(GTM_EVENT_PREMIUM_SUGAR_DADDY_CLICK_2, auth.user)" :to="{name: 'user', params: {id: bubble.payload.user.id}}">{{$t(`notifications.actions.check.${bubble.payload.user.gender === TYPE_GENDER_FEMALE ? 'female' : 'male'}`)}}</router-link>
    </div>
</template>

<script>
import { getUserPhotoURL } from "@/service/user/profile";
import { TYPE_GENDER_FEMALE } from "@/types/user";
import { getOrCreate } from "@/api/messages";
import AuthenticatedMixin from "@/mixins/AuthenticatedMixin";
import {
    GTM_EVENT_PREMIUM_SUGAR_DADDY_OPEN, GTM_EVENT_PREMIUM_SUGAR_DADDY_CLICK_1, GTM_EVENT_PREMIUM_SUGAR_DADDY_CLICK_2
} from "@/service/gtm/types";
import { pushDataLayer } from "@/service/gtm";
import toastr from "toastr";
import { mapActions } from "vuex";
import ThemeMixin from "@/mixins/ThemeMixin";

export default {
    name: "PremiumSugarDaddy",
    mixins: [AuthenticatedMixin, ThemeMixin],
    props: {
        bubble: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            working: false
        }
    },
    methods: {
        pushDataLayer,
        getUserPhotoURL,
        ...mapActions({
            addPreAction: "profile/add"
        }),
        async messageUser() {
            this.working = true
            try {
                const { data } = await getOrCreate(this.bubble.payload.user.id)
                pushDataLayer(GTM_EVENT_PREMIUM_SUGAR_DADDY_CLICK_1, this.auth.user)
                this.working = false
                await this.$router.push({name: 'messages', params: {conversation: data.id}})
            } catch(e) {
                if(e?.response?.status === 406) {
                    await this.addPreAction('daily_limit')
                } else {
                    toastr.error(this.$i18n.t('credits.error_processing'))
                }
            }

            this.$emit('close')
        }
    },
    created() {
        this.TYPE_GENDER_FEMALE                     = TYPE_GENDER_FEMALE
        this.GTM_EVENT_PREMIUM_SUGAR_DADDY_CLICK_2  = GTM_EVENT_PREMIUM_SUGAR_DADDY_CLICK_2
    },
    mounted() {
        pushDataLayer(GTM_EVENT_PREMIUM_SUGAR_DADDY_OPEN, this.auth.user)
    }
}
</script>
